
function Slugify(string) {
  return string.replace(/ /g, '-');
  }
  export default Slugify